import { Component, OnInit } from '@angular/core';
import { SearchService } from './services/search';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  results: any[];
  query: string;

  constructor(private search: SearchService) {}

  ngOnInit() {
    this.search.collection$.subscribe((data: any[]) => this.results = data);
  }

  getSearch() {
    // this.search.search(this.query);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts